import { render } from "./AssistantWidget.vue?vue&type=template&id=6f76931f&scoped=true"
import script from "./AssistantWidget.vue?vue&type=script&lang=js"
export * from "./AssistantWidget.vue?vue&type=script&lang=js"

import "./AssistantWidget.vue?vue&type=style&index=0&id=6f76931f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f76931f"]])

export default __exports__